var staticGallery3DView = {
};

function gallery3DView(id,props) {
	this.ident = id;
	this.properties = props;
	this.showhelp = 0;

	swipe = new swiper();

	swipe.setCenter($("#player").width() * 0.5, $("#player").height() * 0.5, 0.5);
	//$("#menubutton").hide();
	//$("#mapbutton").hide();
	//$("#menu").hide();
	
	player.bottomBar(true);

	$("#info").hide();	
}

gallery3DView.prototype = {
	rx: 0,
	ry: 0,
	px: 0,
	py: 0,
	inX: 0,
	inY: 0,
	autoX: -1,
	panning:false,
	swipe:{},
	pd:null,
	gps:null,
	title:null,
	ia:null,
	node:null,
	content:null,
	w:0,
	h:0,
	opened:false,
	helpanim:true,
	lastX:0,
	lastY:0,
	flying:true,
	
	load: function() {
		AppEvent.trigger(player, "PLACE.LOADED", player.currentView);
		
		$("#player").css("background-color","#000000");
		$("#player").html("");
		$("#menubutton").hide();
		
		if ((player.lastIdent == undefined || player.lastIdent == null || player.lastIdent == player.ident) && player.current.properties.exit != undefined && player.current.properties.exit != "0") {
			player.addTrack(player.current.properties.exit, player.current.properties.exit_angle);
			player.lastIdent = player.current.properties.exit;
			player.lastDir = player.current.properties.exit_angle;
		}
		
		staticGallery3DView.self = this;
		
		//console.log(this.properties);
		
		this.gal3d = $("<div id='gal3d'></div>");
		this.content = $("<Div id='galcontent'></div>");
		this.gal3d.append(this.content);
		$("#player").append(this.gal3d);
		this.closebtn = $("<div style='position:absolute;right:10px;top:5px;width:50px;height:50px;'><img src='assets/menu_close.png' on" +Events.pointer.up + "='staticGallery3DView.self.closeGallery();' id='galclose' style='left:0px' title='Zamknij' class='speaks' data-speak='PLAYER.CLOSE' data-speakgroup='TIPS'></div>");
		this.gal3d.append(this.closebtn);

		var self = this;

		this.closebtn.on("mouseover", function() {
			self.flying = false;
		});

		this.closebtn.on("mouseout", function() {
			self.flying = true;
		});

		this.node = new css3DNode("#galcontent");
		
		//this.content.css("width", "1800px");
		//this.content.css("left", "-400px");
		
		var tw = $(window).width() * 0.2;
		if (tw < 130) tw = 100;
		var th = tw * 0.5;

		var fs = Math.round(24 * tw / 384);
		if (fs > 32) fs = 24;
		
		for(var i = 0; i < this.properties.properties.gallery.length; i ++) {
			var photo = this.properties.properties.gallery[i];
			var desc = "";
			if (photo.title != undefined && photo.title != "") {
				desc = "<div class='bdrop'></div><div class='label' style='font-size:" + fs + "px;line-height:" + Math.round(fs * 1.4) + "px'>" + photo.title + "</div>";
			}

			var ltitle = photo.title;
			if (ltitle != "") ltitle = "Kliknij aby powiększyć: " + ltitle;
			else ltitle = "Kliknij aby powiększyć";

			if (player.offline)
				this.content.append($("<div class='galthumb' on" + Events.pointer.up + "='staticGallery3DView.self.open(" + i + ")' data-no='" + i + "'><div class='img'><img src='data/" + photo.file + "' width='" + tw + "' height='" + th + "' title='" + ltitle + "'>" + desc + "</div></div>"));
			else
//				this.content.append($("<div class='galthumb thumbloading' on" + Events.pointer.up + "='staticGallery3DView.self.open(" + i + ")'><img src='" + photo.thumb + "' width='" + tw + "' height='" + th + "' onload='staticGallery3DView.self.thumbloaded(this);'>" + desc + "</div>"));
				this.content.append($("<div class='galthumb thumbloading' on" + Events.pointer.up + "='staticGallery3DView.self.open(" + i + ")' data-no='" + i + "'><div class='img'><img src='" + photo.thumb + "' width='" + tw + "' height='" + th + "' onload='staticGallery3DView.self.thumbloaded(this);' title='" + ltitle + "'>" + desc + "</div></div>"));
		}
		this.w = this.content.width();
		this.h = this.content.height();
		
		if (this.h > $(window).height()) this.content.css("width", (this.w * 2) + "px");
		//this.content.css("height", (this.h - 50) + "px");
		
		this.w = this.content.width();
		this.h = this.content.height();
		
		this.overlay = $("<div id='galoverlay'></div>");
		$("#player").append(this.overlay);

		SpeechManager.enableSpeech("#gal3d", ".speaks", 1, "TOPMENU");

		this.help = $("<Div id='galhelp'><div class='left hstart'><i class='fa fa-angle-left'></i>
</div><div class='right hstart'><i class='fa fa-angle-right'></i></div><div class='top hstart'><i class='fa fa-angle-up'></i></div><div class='bottom hstart'><i class='fa fa-angle-down'></i></div></div>");
		this.gal3d.append(this.help);

		AppEvent.trigger(player, "PLACE.LOADED", player.currentView);

		var self = this;

		setTimeout(function() { self.help.find(".hstart").removeClass("hstart"); }, 1000);
		setTimeout(function() { self.help.find("div").css("opacity", 0); self.helpanim = false;}, 5000);

		Tab.add("hotspots", {
			"focus": function(m) {
				staticGallery3DView.self.kmode = true;
				$(m.content.find(".galthumb").eq(0)).addClass("focused");
				$(m.content.find(".galthumb").eq(0)).addClass("hovered");
				m.gpx = 0;
				m.gpy = 0;
				m.dst_x = 0;
				m.dst_y = 0;

				var ltop = $(m.content.find(".galthumb").eq(0)).offset().top;
				var self = this;
				self.inrow = 0;
				self.rows = 0;

				m.content.find(".galthumb").each(function() {
					var ctop = $(this).offset().top;
					if (ctop != ltop) {
						self.rows ++;
					}
					if (self.rows == 0) self.inrow ++;
					ltop = ctop;
				});
			},

			"blur": function(m) {
				staticGallery3DView.self.kmode = false;
				$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("focused");
				$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("hovered");
			},

			"action": function(m, event) {
				var no = $(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).data('no');

				if (!self.opened) {
					staticGallery3DView.self.open(no)
				} else {
					var url = $("#galtitle").data("url");
					var dir = $("#galtitle").data("dir");

					staticGallery3DView.self.goUrl(url, dir);
				}

				event.preventDefault();
				event.stopPropagation();
			},

			"keyboard": function(m, event) {

				if (event.key == "ArrowLeft") {
					if (m.gpx > 0) {
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("hovered");
						m.gpx --;
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("hovered");
					}
				}

				if (event.key == "ArrowRight") {
					if (m.gpx < this.inrow - 1) {
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("hovered");
						if (m.gpx + 1 + m.gpy * this.inrow < m.properties.properties.gallery.length) m.gpx ++;
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("hovered");
					}

					//console.log( $(m.content.find(".galthumb").eq(m.gpx + m.gpy * self.inrow)).offset() );
					//console.log( $(m.content.find(".galthumb").eq(m.gpx + m.gpy * self.inrow)) );					
				}

				if (event.key == "ArrowDown") {
					if (m.gpy < this.rows) {
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("hovered");
						if (m.gpx + (m.gpy + 1) * this.inrow < m.properties.properties.gallery.length) m.gpy ++;
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("hovered");
					}
				}

				if (event.key == "ArrowUp") {
					if (m.gpy > 0) {
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).removeClass("hovered");
						m.gpy --;
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("focused");
						$(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).addClass("hovered");
					}
				}

				var ofs = $(m.content.find(".galthumb").eq(m.gpx + m.gpy * this.inrow)).offset(); 
				var dpx = m.gpx * 400;
				var dpy = m.gpy * 220;
				var scx = -staticGallery3DView.self.px;
				var scy = -staticGallery3DView.self.py;

				if (dpx < scx || dpx > scx + $(document).width()) staticGallery3DView.self.dst_x = -dpx;
				if (dpy < scy || dpy > scy + $(document).height() - 400) staticGallery3DView.self.dst_y = -dpy;

			}
			
		}, this, 0);

		var self = this;
		this.kde = AppEvent.on(player, "PLAYER.KEYDOWN", function(event) {
			if ((event.key == "Escape" || event.key == "Backspace") && self.opened) {
				self.close();

				player.blockBackspace = true;

				event.preventDefault();
				event.stopPropagation();
			}
		});

		AppEvent.trigger(player, "PLACE.TRANSITIONED", this);
	},

	thumbloaded: function(self) {
		$(self).parent().removeClass("thumbloading");
		$(self).parent().parent().removeClass("thumbloading");
	},

	closeGallery: function() {
		player.back();
	},

	close: function() {
		/*
		$("#galgo").css("-webkit-transition", "none");
		$("#galgo").css("-moz-transition", "none");
		$("#galgo").css("transition", "none");
		
		$("#galgo").css("-webkit-transform","translate3d(500px, 0px ,0px)");
		$("#galgo").css("-moz-transform","translate3d(500px, 0px, 0px)");
		$("#galgo").css("opacity","0");
		*/
		this.closebtn.show();

		$("#overlay").show();

		$("#galbig").css("opacity", "0");
		this.opened = false;
		this.flying = true;

		//$("#menu").show();
		//$("#menubutton").show();
		
		player.bottomBar(true);
		this.overlay.hide();

	},
	
	goUrl: function(url, dir) {
		//document.location = url;
		player.go(url, dir);
	},
	
	open: function(id) {
		//console.log(id);
		if (!swipe.isClick()) return;
		//if (swipe.isScrolling()) return;
		
		this.closebtn.hide();

		player.bottomBar(false);

		var photo = staticGallery3DView.self.properties.properties.gallery[id];
		
		var url = photo.id;
		//document.title = "clicked(" + id + ")";
		var dir = "";
		if (photo.rx && photo.ry) dir = photo.rx.toString() + "," + (photo.ry).toString();
		else if (photo.rx) dir = photo.rx.toString();
		//document.title = dir;

		//staticGallery3DView.self.goUrl(url,dir);
		//return;

		var thumb;
		if (player.offline)
			thumb = "data/" + photo.file;
		else
			thumb = photo.thumb;

//		this.overlay.html("<div id='galtitle'>" + photo.title + "</div><img src='assets/back.png?2013120202' on" +Events.pointer.up + "='staticGallery3DView.self.close();' id='galback'><a href='javascript:void(null);' on" +Events.pointer.up + "='staticGallery3DView.self.goUrl(\"" + url + "\",\"" + dir + "\");' id='galgo'><img src='assets/go_icon.png' width='15' style='padding-left:10px;padding-right:10px;vertical-align:middle;'>Zobacz panoramę</a><div id='galbig' style='padding-left:5%;'><img src='" + thumb + "' id='full' width='95%' on" +Events.pointer.up + "='staticGallery3DView.self.close();'></div>");
//		this.overlay.html("<div id='galtitle'>" + photo.title + "</div><div style='position:absolute;left:50%;bottom:0;width:90px;height:90px;'><img src='assets/back.png?2013120202' on" +Events.pointer.up + "='staticGallery3DView.self.close();' id='galback' style='left:-50%'></div><div id='galbig' style='padding-left:5%;'><img src='" + thumb + "' id='full' width='95%' on" +Events.pointer.up + "='staticGallery3DView.self.goUrl(\"" + url + "\",\"" + dir + "\");'></div>");
		var gi = "";
		if (this.showhelp < 2) gi = "<div id='galinfo'>" + TPL.lng('gallery.help', 'Kliknij na zdjęcie aby przejść dalej.') + "</div>";
		this.showhelp ++;

		this.overlay.html("<div id='galtitle' data-url='" + url + "' data-dir='" + dir + "'>" + photo.title + "</div>" + gi + "<div style='position:absolute;right:10px;top:65px;width:50px;height:50px;'><img src='assets/menu_close.png' on" +Events.pointer.up + "='staticGallery3DView.self.close();' id='galback' style='left:0px' title='Zamknij' class='speaks2' data-speak='PLAYER.CLOSE' data-speakgroup='TIPS'></div><div id='galbig' style='padding-left:5%;'><img src='" + thumb + "' id='full' width='95%' on" +Events.pointer.up + "='staticGallery3DView.self.goUrl(\"" + url + "\",\"" + dir + "\");'  title='Kliknij aby wejść dalej'></div>");

		$("#overlay").hide();
		AppEvent.one(player, "beforeLoad",function() { $("#overlay").show(); });

		SpeechManager.enableSpeech("#gal3d", ".speaks2", 1, "TOPMENU");

		setTimeout(function() {
			//document.title = $(window).height() + " , " + $("#galbig").height();
			var top = ($(window).height() * 0.5 - $("#galbig").height() * 0.5);
			$("#galbig").css("margin-top",($(window).height() * 0.5 - $("#galbig").height() * 0.5) + "px");
			$("#galbig").css("opacity", "1");
			
			if (top > 80) {
		//		$("#galtitle").css("top", (top - 50) + "px");
			}
			
			/*
			$("#galgo").css("-webkit-transition", "all 0.3s ease-out 0.3s");
			$("#galgo").css("-moz-transition", "all 0.3s ease-out 0.3s");
			$("#galgo").css("transition", "all 0.3s ease-out 0.3s");
			
			$("#galgo").css("opacity","1");
			$("#galgo").css("-webkit-transform","translate3d(0px,0px,0px)");
			$("#galgo").css("-moz-transform","translate3d(0px,0px,0px)");
			*/
			}, 100);
		var im = new Image();
		im.onload = function() {
			$("#full").attr("src", im.src);
		};

		if (player.offline)
			im.src = "data/" + photo.file;
		else 
			im.src = "../" + photo.path;

		//$("#full").attr("src", "../" + photo.path);
		this.overlay.show();
		this.opened = true;
		
		$("#menu").hide();
		$("#menubutton").hide();


	},
	
	reorient: function() {
	},
	
	process: function() {
		var ix,iy;
		this.rx *= 0.8;
		this.ry *= 0.8;

		if (this.opened || !this.flying) return;
		
		if (this.kmode) {
			
			if (!isNaN(this.dst_x)) this.px = this.px + (this.dst_x - this.px) * 0.03;
			if (!isNaN(this.dst_y)) this.py = this.py + (this.dst_y - this.py) * 0.03;

			if (this.px < -(this.w - $(window).width())) {
				this.px = -(this.w - $(window).width());
			}
			if (this.py < -(this.h - $(window).height() + 140)) this.py = -(this.h - $(window).height() + 140);

			this.node.resetTransform();
			this.node.translate((-this.w * 0.25), 0, -20);
			this.node.translate(this.px + (this.w * 0.25), this.py, 0);
			//this.rx ++;
			this.node.applyTransforms();

			return;
		}

		//document.title = $(window).width() + " x " + $(window).height();
				
		this.inX *= 0.8;
		ix = swipe.inertiaX() * -2;
		this.inX += ix;		
		this.px += this.inX;
		this.rx += ix;
		if (this.rx > 30) this.rx = 30;
		if (this.rx < -30) this.rx = -30;

		if (this.px < -(this.w - $(window).width())) {
			this.px = -(this.w - $(window).width());
			this.autoX = 1;
		}

		if (this.px > 0) {
			this.px = 0;
			this.autoX = -1;
		}
		
		this.inY *= 0.8;
		iy = swipe.inertiaY() * -2.5;
		this.inY += iy;
		this.py -= this.inY;
		this.ry += iy;
		if (this.ry > 30) this.ry = 30;
		if (this.ry < -30) this.ry = -30;
		if (this.py < -(this.h - $(window).height() + 140)) this.py = -(this.h - $(window).height() + 140);
		if (this.py > 0) this.py = 0;

		this.px += this.autoX * 0.3;

		this.px += swipe.distFromCenterX * -0.01;
		this.py += swipe.distFromCenterY * -0.02;

		if (!this.helpanim) {
			if (swipe.distFromCenterX < 0 && Math.abs(this.lastX - this.px) > 1) this.help.find(".left").css("opacity", 1); else this.help.find(".left").css("opacity", 0);
			if (swipe.distFromCenterX > 0 && Math.abs(this.lastX - this.px) > 1) this.help.find(".right").css("opacity", 1); else this.help.find(".right").css("opacity", 0);
			if (swipe.distFromCenterY < 0 && Math.abs(this.lastY - this.py) > 1) this.help.find(".top").css("opacity", 1); else this.help.find(".top").css("opacity", 0);
			if (swipe.distFromCenterY > 0 && Math.abs(this.lastY - this.py) > 1) this.help.find(".bottom").css("opacity", 1); else this.help.find(".bottom").css("opacity", 0);
		}

		this.node.resetTransform();
		this.node.translate((-this.w * 0.25), 0, -20);
		this.node.rotateY(this.rx);
		this.node.rotateX(this.ry);
		//this.node.translate(400, 0, 0);
		this.node.translate(this.px + (this.w * 0.25), this.py, 0);
		//this.rx ++;
		this.node.applyTransforms();

		this.lastX = this.px;
		this.lastY = this.py;
	},
		
	mouseDown: function(event) {
		this.panning = true;
		swipe.start(event);
//		swipe.start(event.originalEvent.touches);
	},
	
	mouseUp: function(event) {
		swipe.end();
		this.panning = false;
	},
	
	mouseMove: function(event) {
		swipe.move(event);
//		swipe.move(event.originalEvent.touches);
	},

	mouseWheel: function(dt) {
	},

	pause: function() {
		this.paused = true;
	},

	resume: function() {
		this.paused = false;
	},

	leaving: function() {
		player.bottomBar(true);

		var self = this;

		AppEvent.one(player, "PLACE.TRANSITIONED", function() {
			self.gal3d.remove();
			self.overlay.remove();

			self.kde.remove();
		});
	}
}